import { MS_IN_SEC } from 'utils/constants'

export const STORAGE_KEY_INSIGHTS_REFRESH = 'insights-refresh-cooldown'

type CooldownMap = { [ppid: string]: number }

function readAll(): CooldownMap {
  if (!localStorage) {
    console.error('Local Storage not supported')
    return {}
  }

  const raw = localStorage.getItem(STORAGE_KEY_INSIGHTS_REFRESH)
  if (!raw) {
    return {}
  }

  try {
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed as CooldownMap : {}
  } catch (e) {
    console.error('Could not parse stored insights refresh cooldowns', e)
    return {}
  }
}

function writeAll(cooldowns: CooldownMap) {
  if (!localStorage) {
    console.error('Local Storage not supported')
    return
  }

  try {
    localStorage.setItem(STORAGE_KEY_INSIGHTS_REFRESH, JSON.stringify(cooldowns))
  } catch (e) {
    console.error('Could not store insights refresh cooldown', e)
  }
}

/**
 * Returns the Unix timestamp (seconds) at which this profile may be refreshed again,
 * or null when there is no cooldown or it has already elapsed. Elapsed entries are pruned.
 */
export function getInsightsRefreshRetryAt(ppid: string): number | null {
  const cooldowns = readAll()
  const retryAt = cooldowns[ppid]
  if (!retryAt) {
    return null
  }

  if (retryAt * MS_IN_SEC <= Date.now()) {
    delete cooldowns[ppid]
    writeAll(cooldowns)
    return null
  }

  return retryAt
}

export function setInsightsRefreshRetryAt(ppid: string, retryAt: number) {
  const cooldowns = readAll()
  cooldowns[ppid] = retryAt
  writeAll(cooldowns)
}
